import { ResponsiveStream } from "@nivo/stream";
import { color } from "../styles/theme";

const PoolChart = ({ data }) => (
	<ResponsiveStream
		data={data}
		keys={["DAI"]}
		// margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
		axisTop={null}
		axisRight={null}
		axisBottom={{
			orient: "bottom",
			tickSize: 5,
			tickPadding: 5,
			tickRotation: 0,
			legend: "",
			legendOffset: 36,
		}}
		axisLeft={{
			orient: "left",
			tickSize: 5,
			tickPadding: 5,
			tickRotation: 0,
			legend: "",
			legendOffset: -40,
		}}
		enableGridX={false}
		enableGridY={false}
		curve="basis"
		offsetType="silhouette"
		colors={{ scheme: "nivo" }}
		fillOpacity={0.85}
		borderColor={{ theme: "background" }}
		defs={[
			{
				id: "dots",
				type: "patternDots",
				background: "inherit",
				color: "#2c998f",
				size: 4,
				padding: 2,
				stagger: true,
			},
			{
				id: "squares",
				type: "patternSquares",
				background: "inherit",
				color: color.black,
				size: 6,
				padding: 2,
				stagger: true,
			},
		]}
		fill={[
			{
				match: {
					id: "Paul",
				},
				id: "dots",
			},
			{
				match: {
					id: "Marcel",
				},
				id: "squares",
			},
		]}
		dotSize={8}
		dotColor={{ from: "color" }}
		dotBorderWidth={2}
		dotBorderColor={{
			from: "color",
			modifiers: [["darker", 0.7]],
		}}
		legends={[
			{
				anchor: "bottom-right",
				direction: "column",
				translateX: 100,
				itemWidth: 80,
				itemHeight: 20,
				itemTextColor: color.black,
				symbolSize: 12,
				symbolShape: "circle",
				effects: [
					{
						on: "hover",
						style: {
							itemTextColor: color.black,
						},
					},
				],
			},
		]}
	/>
);

export default PoolChart;
